import { useState } from 'react'
import { Info } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useFieldContext } from '@/lib/form-contexts'
import { cn } from '@/lib/utils'

export function PriceAdjustmentFieldInfo({ className }) {
  const field = useFieldContext()
  const errors = Array.isArray(field.state.meta.errors) ? field.state.meta.errors : []

  if (errors.length === 0) {
    return null
  }

  return (
    <div className={cn('text-sm text-destructive', className)}>
      {errors.map((error, index) => {
        const message =
          typeof error === 'string'
            ? error
            : typeof error?.message === 'string'
              ? error.message
              : (error?.toString?.() ?? '')

        return (
          <div key={`${field.name}-error-${index}`} className={cn(index > 0 ? 'mt-1' : null)}>
            <span>{message}</span>
          </div>
        )
      })}
    </div>
  )
}

export function PriceAdjustmentPriorityLabelInfo() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant="ghostMuted"
        size="icon-3xs"
        aria-label="About price change priority"
        className="ml-1"
        onClick={() => setOpen(true)}
      >
        <Info className="size-3.5" aria-hidden="true" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent size="compact">
          <DialogHeader>
            <DialogTitle>About Priority</DialogTitle>
            <DialogDescription>
              Most price changes should stay Normal. Use Priority only when schedules overlap and
              this price change should take the lead over another price change in the same group.
            </DialogDescription>
          </DialogHeader>
          <div className="rounded-xl bg-status-info-background p-4 text-sm leading-6 text-status-info-foreground ring-1 ring-inset ring-status-info-border">
            Collection price changes still take the lead over All Products for products in those
            collections.
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => setOpen(false)}>
              Got it
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
